import { FC, HTMLAttributes, MouseEventHandler, MutableRefObject } from 'react';

import { ButtonStyled } from '../../Typhography/ButtonStyled';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  width?: number | string;
  height?: number | string;
  color?: string;
  margin?: number | string;
  variant?: 'primary' | 'link' | 'secondary' | 'cancel' | 'danger' | 'success' | 'white';
  minWidth?: number;
  display?: string;
  fontSize?: number;
  innerRef?: MutableRefObject<HTMLButtonElement | undefined>;
  style?: any;
  className?: string;
}

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  disabled,
  type = 'button',
  width,
  height,
  color,
  margin,
  variant,
  minWidth,
  display,
  fontSize,
  innerRef,
  style,
  className,
  ...rest
}) => {
  return (
    <ButtonStyled
      {...rest}
      className={className}
      color={color}
      width={width}
      height={height}
      onClick={onClick}
      disabled={disabled}
      type={type}
      margin={margin}
      variant={variant}
      minWidth={minWidth}
      display={display}
      fontSize={fontSize}
      innerRef={innerRef}
      style={style}
    >
      {children}
    </ButtonStyled>
  );
};

export default Button;
